import React, { useState } from "react";
import styled from "styled-components";
import TextRenderer from "./TextRenderer";
import smallLogo from "../../Assets/Farazandishan-logo-2.png"
import { TextInputWTitle } from "../Helper/TextInputWTitle";
import { TextBtn } from "../Helper/TextBtn";

const Style = styled.div`
    display: flex;
    position: relative;
    isolation: isolate;
    .bg-image {
        z-index: 1;
        position: absolute;
        inset: 0;
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
        }
    }
    .cover {
        z-index: 2;
        position: absolute;
        inset: 0;
        background-color: #00000088;
    }
    .container-box {
        z-index: 3;
        display: flex;
        width: calc(100% - 140px);
        padding: 5rem 70px 5rem;
        gap: 1rem;
    }
    .data {
        width: 50%;
        z-index: 3;
        display: flex;
        flex-direction: column;
        justify-content: end;
        text-align: center;
        gap: 1.5rem;
        .title {
            font-size: 2rem;
            font-weight: 800;
            color: #fff;
        }
        .box {
            position: relative;
            background-color: #f5faff;
            box-shadow: var(--n-shadow-1);
            padding: 2rem;
            border-radius: 8px;
            display: flex;
            flex-direction: column;
            overflow: hidden;
            .logo-overlay {
                position: absolute;
                width: 100px;
                top: -20px;
                left: -20px;
                filter: grayscale(50%) blur(2px);
                opacity: 0.3;
            }
            .input-resume {
                padding: calc(var(--fs-textfield)) calc(1rem - 1px) var(--fs-textfield);
                display: flex;
                gap: 1rem;
                justify-content: start;
                align-items: center;
                border: 1px var(--bg-d-3) solid;
                margin: 0 0 0.5rem 0;
                border-radius: 8px;
            }
        }
    }
    @media (max-width: 850px){
        .container-box {
            width: calc(100% - 32px);
            padding: 3rem 16px 3rem;
            flex-direction: column;
        }
        .data { 
            width: 100%;
            justify-content: end;
            .box {
                padding: 2rem 1rem;
            }
        }
    }
`;

export default function ResumeBox({pageHeight, data}) {
    const [fullname, setFullName] = useState("");
    const [mobile, setMobile] = useState("");
    const [email, setEmail] = useState("");
    const [resume, setResume] = useState("");

    onchange = (e) => {
        switch(e.target.name){
            case 'fullname':
                setFullName(e.target.value);
                break;
            case 'mobile':
                setMobile(e.target.value);
                break;
            case 'email':
                setEmail(e.target.value);
                break;
            case 'resume':
                setResume(e.target.value);
                break;
            default:
                break;
        }
    }

    return (
      <Style>
        <div className="bg-image">
            <img src={data.data.bgimage} alt={data.title}/>
        </div>
        <div className="cover">
        </div>
        <div className="container-box">
            <div className="data">
                <div className="title">
                    {data.data.title}
                </div>
                <div className="box">
                    {/* <img className="logo-overlay" src={smallLogo} alt="farazandishan"/> */}
                    <TextRenderer data={data.data.text}/>
                </div>
            </div>
            <div className="data">
                <div className="box">
                    <TextInputWTitle
                        title={"Full Name"}
                        name={"fullname"}
                        value={fullname}
                        onchange={onchange}
                        error=""
                        ltr={true}
                    />
                    <TextInputWTitle
                        title={"Mobile"}
                        name={"mobile"}
                        value={mobile}
                        onchange={onchange}
                        error=""
                        ltr={true}
                    />
                    <TextInputWTitle
                        title={"Email"}
                        name={"email"}
                        value={email}
                        onchange={onchange}
                        error=""
                        ltr={true}
                    />
                    <div className="input-resume">
                        resume: <input type={"file"} accept="pdf"/>
                    </div>
                    <TextBtn
                        loading={false}
                        disabled={false}
                        text={"Send"}
                    />
                </div>
            </div>
        </div>
      </Style>
  );
}
